import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const WarningFilled = createSvgIcon(
  <path d="M24 24 12 0 0 24h24ZM13.125 8.25v8.25h-2.25V8.25h2.25Zm0 10.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0Z" />,
  'WarningFilled'
);

export { WarningFilled };